const SHOW_NOTCH = false;
export const CHAT_SENDER_POSITION = "right";
export const CHAT_RECEIVER_POSITION = "left";

export const CHAT_WIDGET_STATUS = {
  CLOSED: 0,
  OPEN: 1,
  SUSPENDED: 2,
};

export const messageToRequiredFormat = (msg) => ({
  type: "text",
  text: msg,
  dateString: new Date().toLocaleTimeString(),
  notch: SHOW_NOTCH,
});

export const convertStudentMessagesToRequiredFormat = (msgList, studentId) => {
  const newList = msgList.map(msg => ({
    text: msg.message_content,
    type: "text",
    dateString: msg.created_at,
    notch: SHOW_NOTCH,
    position: studentId === msg.sent_to ? CHAT_SENDER_POSITION : CHAT_RECEIVER_POSITION,
    messageReadByOtherSide: msg.message_read_by_other_side,
  }));
  return newList;
};
